import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DspxLogoutComponent } from 'dspx-core';
import { ROUTE_CONSTANTS } from './constants/route.constants';
import { ComponentDeactivationService } from "./services/component-deactivation.service";
import { LandingComponent } from "./components/landing/landing.component";
import { StaticPageComponent } from './components/static-page/static-page.component';
import { IntegrityOfficerListComponent } from "./components/integrity-officer-list/integrity-officer-list.component";
import { IntegrityOfficerComponent } from "./components/integrity-officer/integrity-officer.component";
import { ReferenceDataListComponent } from "./components/reference-data-list/reference-data-list.component";
import { ReferenceDataComponent } from "./components/reference-data/reference-data.component";
import { CoiFormListComponent } from "./components/coi-form-list/coi-form-list.component";
import { CoiFormComponent } from './components/coi-form/coi-form.component';
import { ApproverCoiFormComponent } from './components/approver-coi-form/approver-coi-form.component';
import { DopiFormListComponent } from './components/dopi-form-list/dopi-form-list.component';
import { DopiFormComponent } from './components/dopi-form/dopi-form.component';
import { ApproverDopiFormComponent } from './components/approver-dopi-form/approver-dopi-form.component';
import { GbhFormListComponent } from './components/gbh-form-list/gbh-form-list.component';
import { GbhFormComponent } from './components/gbh-form/gbh-form.component';
import { ApproverGbhFormComponent } from './components/approver-gbh-form/approver-gbh-form.component';

const ExternalRoutes: Routes = [
  // COI (Conflict Of Interest) Form
  {
    path: ROUTE_CONSTANTS.coiForm.externalEdit,
    component: CoiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.coiForm.externalView,
    component: CoiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  // DOPI (Declaration Of Private Interests) Form
  {
    path: ROUTE_CONSTANTS.dopiForm.externalEdit,
    component: DopiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.dopiForm.externalView,
    component: DopiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  }
];

const routes: Routes = [
  ...ExternalRoutes, // External routes are matched first, to ensure they are chosen instead of the "home" route.
  {
    // Loading root of site will redirect to the default client route specified in the back-end after successful authentication
    path: ROUTE_CONSTANTS.home,
    component: LandingComponent
  },
  {
    path: ROUTE_CONSTANTS.logout,
    component: DspxLogoutComponent
  },
  {
    path: ROUTE_CONSTANTS.endOfSession,
    component: StaticPageComponent
  },
  {
    path: ROUTE_CONSTANTS.collectionNotice,
    component: StaticPageComponent
  },
  // Integrity Officer
  {
    path: ROUTE_CONSTANTS.integrityOfficer.list,
    component: IntegrityOfficerListComponent
  },
  {
    path: ROUTE_CONSTANTS.integrityOfficer.edit,
    component: IntegrityOfficerComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  // Reference Data
  {
    path: ROUTE_CONSTANTS.referenceData.list,
    component: ReferenceDataListComponent
  },
  {
    path: ROUTE_CONSTANTS.referenceData.prefix,
    component: ReferenceDataComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.referenceData.edit,
    component: ReferenceDataComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  // COI (Conflict Of Interest) Form
  {
    path: ROUTE_CONSTANTS.coiForm.list,
    component: CoiFormListComponent
  },
  {
    path: ROUTE_CONSTANTS.coiForm.prefix,
    component: CoiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.coiForm.edit,
    component: CoiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.coiForm.view,
    component: CoiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.approverCoiForm.edit,
    component: ApproverCoiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.approverCoiForm.view,
    component: ApproverCoiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  // DOPI (Declaration Of Private Interests) Form
  {
    path: ROUTE_CONSTANTS.dopiForm.list,
    component: DopiFormListComponent
  },
  {
    path: ROUTE_CONSTANTS.dopiForm.prefix,
    component: DopiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.dopiForm.edit,
    component: DopiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.dopiForm.view,
    component: DopiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.approverDopiForm.edit,
    component: ApproverDopiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.approverDopiForm.view,
    component: ApproverDopiFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  // GBH (Gifts, Benefits and Hospitality) Form
  {
    path: ROUTE_CONSTANTS.gbhForm.list,
    component: GbhFormListComponent
  },
  {
    path: ROUTE_CONSTANTS.gbhForm.prefix,
    component: GbhFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.gbhForm.edit,
    component: GbhFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.gbhForm.view,
    component: GbhFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.approverGbhForm.edit,
    component: ApproverGbhFormComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.approverGbhForm.view,
    component: ApproverGbhFormComponent,
    canDeactivate: [ComponentDeactivationService]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
